import { useState } from 'preact/hooks';
import { useWeekData } from './hooks/useWeekData';
import { getWeekEnd } from './utils';
import { NavBar } from './components/NavBar';
import { Header } from './components/Header';
import { ErrorBanner } from './components/ErrorBanner';
import { Verdict } from './components/Verdict';
import { Insight } from './components/Insight';
import { HeroCards } from './components/HeroCards';
import { CalorieChart } from './components/CalorieChart';
import { MacrosPanel } from './components/MacrosPanel';
import { WorkoutPanel } from './components/WorkoutPanel';
import { SystemNotes } from './components/SystemNotes';
import { DaysBreakdown } from './components/DaysBreakdown';

export function App() {
  const [offset, setOffset] = useState(0);
  const { days, prevDays, activities, calError, stravaError, loading } = useWeekData(offset);

  const end = getWeekEnd(offset);
  const startD = (() => {
    const d = new Date(end + 'T00:00:00');
    d.setDate(d.getDate() - 6);
    return d.toISOString().slice(0, 10);
  })();

  const errorMsg = calError ? 'CALORIES API OFFLINE' : stravaError && !stravaError.startsWith('http') ? stravaError : null;

  return (
    <div class="page">
      <NavBar />
      <Header
        startDate={startD}
        endDate={end}
        onPrev={() => setOffset((o) => o - 1)}
        onNext={() => setOffset((o) => o + 1)}
        canNext={offset < 0}
      />
      <ErrorBanner message={errorMsg} />

      {loading ? (
        <div class="verdict loading" />
      ) : (
        <>
          <Verdict days={days} activities={activities} calError={calError} />
          <Insight days={days} activities={activities} />
          <HeroCards days={days} prevDays={prevDays} activities={activities} />
          <CalorieChart days={days} />
          <div class="row2">
            <MacrosPanel days={days} />
            <WorkoutPanel activities={activities} stravaError={stravaError} />
          </div>
          <SystemNotes days={days} />
          <DaysBreakdown days={days} />
        </>
      )}
    </div>
  );
}
